var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4.511,
    height: 7.381,
    viewBox: "0 0 4.511 7.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "back-arrow",
    d: "M26.27,17.24a.82.82,0,0,1,0,1.16l-2.29,2.29,2.29,2.29a.82.82,0,0,1-1.16,1.16l-2.87-2.87a.82.82,0,0,1,0-1.16l2.87-2.87A.82.82,0,0,1,26.27,17.24Z",
    transform: "translate(-22 -17)",
    fill: "#23262f",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.8ece4fee2463ada05fa25f9176808a18.svg";
export { ForwardRef as ReactComponent };